<template lang="html">
  <v-card max-height="90vh">
    <v-toolbar dark color="primary">
      <v-btn icon dark @click="$emit('update:dialog', false)">
        <v-icon>close</v-icon>
      </v-btn>
      <v-toolbar-title>Invoice</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn dark flat @click="saveInvoice()">Save</v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-layout row max-height="90vh">
      <v-flex md8>
        <v-card flat tile >
          <v-img :src="invoice.invoice_file.url" max-height="90vh" fill-height contain/>
        </v-card>
      </v-flex>
      <v-flex md4 pt-1>
        <span class="headline">Details</span>
        <v-divider />
        <v-container grid-list-xl>
          <v-layout row wrap>
            <v-flex md6>
              <v-dialog
                ref="dialog"
                v-model="modal"
                :return-value.sync="invoice.invoice_date"
                persistent
                lazy
                full-width
                width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="invoice.invoice_date"
                    label="Invoice Date"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                    @blur="invoice.invoice_date = parseDate(invoice.invoice_date)"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="date" scrollable>
                  <v-spacer></v-spacer>
                  <v-btn flat color="primary" @click="modal = false">Cancel</v-btn>
                  <v-btn flat color="primary" @click="$refs.dialog.save(invoice.invoice_date)">OK</v-btn>
                </v-date-picker>
              </v-dialog>
            </v-flex>
            <v-flex md6>
              <v-text-field
                label="Invoice Number"
                v-model="invoice.invoice_number" />
            </v-flex>
            <v-flex md12>
              <v-text-field
                label="Dealer Name"
                v-model="invoice.dealer_name" />
            </v-flex>
            <v-flex md8>
              <v-text-field
                name="dealer name"
                label="Dealer City"
                v-model="invoice.dealer_city" />
            </v-flex>
            <v-flex md4>
              <v-text-field
                name="dealer name"
                label="Dealer State"
                v-model="invoice.dealer_state" />
            </v-flex>
          </v-layout>
        </v-container>
        <span class="headline" v-if="$auth.role === 'Super Admin'">Line Items</span>
        <v-divider v-if="$auth.role === 'Super Admin'" />
        <v-container grid-list-md class="scroll-y" v-if="$auth.role === 'Super Admin'">
          <v-layout row wrap v-for="item in invoice.invoice_lines" :key="item.id">
            <v-flex md5>
              <v-text-field
                name="description"
                label="Description"
                :rules="[rules.required]"
                v-model="item.description" />
            </v-flex>
            <v-flex md4>
              <v-currency-field
                label="Amount"
                v-bind="currency_config"
                v-model="item.amount" />
            </v-flex>
            <v-flex md3>
              <v-currency-field
                label="Co-Op Amount"
                v-bind="currency_config"
                v-model="item.co_op_amount" />
            </v-flex>
          </v-layout>
          <v-btn color="primary" @click="addLine()">New Line</v-btn>
        </v-container>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
import _ from 'lodash'
export default {
  name: 'Invoice',
  data () {
    return {
      currency_config: {
        decimal: '.',
        thousands: ',',
        prefix: '$',
        precision: 2,
        masked: false,
        allowBlank: false,
        min: Number.MIN_SAFE_INTEGER,
        max: Number.MAX_SAFE_INTEGER
      },
      rules: {
        required: value => !!value || 'Required.'
      },
      modal: false,
      date: new Date().toISOString().substr(0, 10)
    }
  },
  props: ['invoice', 'dialog', 'test1', 'jobId'],
  mounted () {
    if (this.invoice.invoice_lines.length === 0) {
      this.addLine()
      this.addLine()
      this.addLine()
    }
  },
  watch: {
    date (val) {
      this.invoice.invoice_date = this.formatDate(this.date)
    }
  },
  methods: {
    addLine () {
      this.invoice.invoice_lines.push({
        description: '',
        amount: 0,
        co_op_amount: null
      })
    },
    formatDate (date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${month}/${day}/${year}`
    },
    co_op (event) {
      console.log(event)
    },
    cleanLineItems () {
      this.invoice.invoice_lines = _.filter(this.invoice.invoice_lines, 'description')
    },
    parseDate (date) {
      if (!date) return null

      const [month, day, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    saveInvoice () {
      this.cleanLineItems()
      this.$http({
        method: 'put',
        url: '/admin/jobs/' + this.jobId + '/invoices/' + this.invoice.id,
        data: this.invoice
      }).then((response) => {
        this.$emit('update:dialog', false)
      })
      // axios({
      //   method: 'put',
      //   url: process.env.API_URL + '/api/v1/admin/jobs/' + this.jobId + '/invoices/' + this.invoice.id,
      //   headers: {'Authorization': 'Token token=' + process.env.WORKBENCH_TOKEN},
      //   data: this.invoice
      // }).then((response) => {
      //   this.$emit('update:dialog', false)
      // }).catch((err) => {
      //   console.log(err)
      // })
    }
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// src/components/admin/Jobs/invoice.vue